const getTrackers = state => state.view.trackers || [];

export default getTrackers;
